import React, { Component, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import * as API from "../../core/service/api.js";

import logo from "../../assets/images/logo-default.svg";
import logoWhite from "../../assets/images/logo-white.svg";
import logoCompany from "../../assets/images/logo-company.svg";
import ellipse1 from "../../assets/images/icon_login/ellipse1.svg";
import ellipse2 from "../../assets/images/icon_login/ellipse2.svg";
import ellipse3 from "../../assets/images/icon_login/Ellipse3.svg";
import ellipse4 from "../../assets/images/icon_login/Ellipse4.svg";

import Company from "../../core/models/company.js";
import { setLoading } from "../../core/feature/config/configSlice";
import { removeToken, setToken } from "../../core/feature/token/tokenSlice";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import User from "../../core/models/user.js";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import fingerPrint from "@fingerprintjs/fingerprintjs";
import Token from "../../core/models/token.js";
import { findIndex } from "lodash";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { createPassword } from "../../core/service/api_profile.js";
import { toast } from "react-toastify";
import eye from "../../assets/images/icon_login/eye.svg";
import eyeclose from "../../assets/images/icon_login/eyeclose.svg";
import { getUser } from "../../core/service/api_card.js";
import { t } from "i18next";
import CustomApp from "../../core/models/customApp.js";
import { useAppSelector } from "../../core/feature/hooks";
import { removeCompany } from "../../core/feature/company/companySlice";

const ConfirmationDataWeb = () => {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const location: any = useLocation();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [credential, setCredential] = useState<any>({});
  const [resCredential, setResCredential] = useState<any>({});
  const [resLogin, setResLogin] = useState<any>({});
  const [typePassword, setTypePassword] = useState("password");
  const [typePassword2, setTypePassword2] = useState("password");
  const [disableNextButton, setDisableNextButton] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );

  const next = async () => {
    const regexEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

    if (email && !phone) {
      if (!regexEmail.test(email)) {
        return toast.warning(t("LOGIN.warningEmail"));
      }
    }

    if (phone && !email) {
      if (phone.length < 10) {
        return toast.warning(t("LOGIN.warningWA"));
      }
    }
    var query = {
      email: email,
      password: credential?.password,
      phone: phone,
    };
    dispatch(setLoading(true));
    createPassword(query)
      .then((res) => {
        dispatch(setLoading(false));
        localStorage.setItem("auto_login", "1");

        navigate("intro", {
          replace: true,
          state: {
            credential: credential,
            email: email,
            phone: phone,
          },
        });
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log("f", err);
      });
  };

  const checkEmail = async (value: any) => {
    setEmail(value);
    setDisableNextButton(!value && !phone);
  };

  const checkWA = async (value: any) => {
    setPhone(value);
    setDisableNextButton(!value && !email);
  };
  useEffect(() => {
    setCredential(location.state.credential);

    if (!location.state.email && !location.state.phone) {
      setDisableNextButton(true);
    } else {
      setDisableNextButton(false);
    }

    setEmail(location.state.email);
    setPhone(location.state.phone);
  }, []);
  return (
    <>
      <div className="relative font-montserrat p-0 m-0 bg-psp-primary">
        <div className="flex min-h-screen">
          <div className="w-1/3 sm:w-1/2 md:w-1/3 flex-0 bg-psp-login relative">
            <img
              src={ellipse1}
              className="absolute bottom-0 left-0 z-0 select-none"
            />
            <img
              src={ellipse2}
              className="absolute top-0 left-0 z-0 select-none"
            />

            <div className="mt-48 sm:mt-36 md:mt-48 flex flex-col items-start z-10 p-10 gap-8">
              <img src={logoWhite} className="z-10 h-14 select-none" />
              <p className="text-white z-10 mt-6 text-xs font-light">
                {t("LOGIN.description")}
              </p>
            </div>
          </div>
          <div className="flex w-full p-16 bg-psp-primary relative">
            <div className="px-4 pb-0 pt-12 z-10 w-full">
              <h1 className="text-gray-400 text-2xl font-medium select-none">
                Welcome To
              </h1>
              <p className="text-black font-semibold text-4xl select-none">
                PSP Web Dekstop
              </p>
              <h1 className="text-psp-primary text-3xl font-semibold">
                {`${t("CONFIRMATIONDATA.title")}`}
              </h1>
              <p className="mt-6 text-sm font-normal text-black">
                {t("CONFIRMATIONDATA.subtitle")}
              </p>
              <div className="flex flex-col gap-2">
                <div className="flex flex-col gap-2">
                  <h1 className="font-montserrat  text-sm text-[#B9B9B9] leading-5 font-medium pl-1 mb-0">
                    Email
                  </h1>
                  <input
                    type="text"
                    value={email}
                    onChange={(e) => checkEmail(e.target.value)}
                    className="px-3 grow text-sm rounded-lg h-10 border-1 border-psp-gray border-solid disabled:text-psp-nav"
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <h1 className="font-montserrat  text-sm text-[#B9B9B9] leading-5 font-medium pl-1 mb-0">
                    Nomor Whatsapp
                  </h1>
                  <input
                    type="phone"
                    value={phone}
                    onChange={(e) => checkWA(e.target.value)}
                    className="px-3 grow text-sm rounded-lg h-10 border-1 border-psp-gray border-solid disabled:text-psp-nav"
                  />
                </div>
              </div>
              <button
                disabled={disableNextButton}
                onClick={() => next()}
                className={
                  disableNextButton
                    ? `px-4 mt-4 bg-[#a0a0a0] text-[#EAEAEA] font-bold text-sm items-center justify-center  w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-[#888]`
                    : `px-4 mt-4 bg-[#0054E6] text-[#EAEAEA] font-bold text-sm items-center justify-center  w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-psp-active`
                }
              >
                {t("OTHER.next")}
              </button>
              <button
                onClick={() => (
                  navigate("/login", { replace: true }),
                  dispatch(removeCompany),
                  dispatch(removeToken),
                  dispatch(removeUser)
                )}
                className="px-4 mt-2 bg-transparent border-[0.5px] border-solid border-[#0054E6] text-[#0054E6] font-bold text-sm items-center justify-center  w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-psp-active"
              >
                {t("OTHER.back")}
              </button>
            </div>
            <img src={ellipse3} className="absolute top-0 -left-72 -z-0" />
            <img src={ellipse4} className="absolute bottom-0 right-0 -z-0" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmationDataWeb;
